export default {_name:'checkbox',module:'Field',view:'Element/Field/Check'}